import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import DefaultLayout from './containers/Layouts/DefaultLayout';
import { ThemeProvider } from '@mui/material/styles';
import { defaultTheme } from './style/DefaultTheme';
import ConfigurationService from './services/ConfigurationService';
import { IntlProvider } from 'react-intl';
import i18n from 'i18n/I18nInstance';
import queryString from 'query-string';
import AnalyticsService from 'services/AnalyticsService';
import AnalyticsData from 'model/AnalyticsData';
import { ContentType, EventType } from 'model/enums';
import Configuration from 'model/Configuration';

export interface IState {
    configRetrieved: boolean;
    disablePrintMobileOnly: boolean;
    brandName: string;
    language: string;
    jwt: string | undefined;
}

const DEFAULT_BRAND_NAME = 'CAREKIT';
const APP_TITLE = 'Patient Portal Integration';

function App() {
    const location = useLocation();
    const [state, setState] = React.useState<IState>({
        brandName: DEFAULT_BRAND_NAME,
        configRetrieved: false,
        jwt: undefined,
        language: i18n.CurrentLanguage,
        disablePrintMobileOnly: false,
    });

    React.useEffect(() => {
        const queryStringParsed = queryString.parse(location.search);
        if (queryStringParsed && queryStringParsed.language) {
            i18n.changeLanguage(queryStringParsed.language);
        }
    }, [location.search]);

    React.useEffect(() => {
        async function fetchConfig() {
            let params = new URLSearchParams(window.location.search);
            let sessionId = params.get('sessionId');
            const config = await ConfigurationService.retrieveConfigurationForSession(sessionId);
            sendAnalytics(config);
            setState({
                brandName: config.brandName,
                disablePrintMobileOnly: config.disablePrintMobileOnly,
                configRetrieved: true,
                jwt: config.jwt,
                language: i18n.CurrentLanguage,
            });
        }
        fetchConfig();
    }, []);

    const sendAnalytics = async (config: Configuration) => {
        const analyticsData: AnalyticsData = {
            eventType: EventType.AppLaunch,
            contentType: ContentType.Page,
            title: APP_TITLE,
        };
        await AnalyticsService.recordEvent(analyticsData, config);
    };

    if (state.configRetrieved) {
        return (
            <IntlProvider locale={state.language} messages={i18n.CurrentMessages}>
                <ThemeProvider theme={defaultTheme}>
                    <Routes>
                        <Route
                            path="/*"
                            element={
                                <DefaultLayout
                                    brandName={state.brandName}
                                    disablePrintMobileOnly={state.disablePrintMobileOnly}
                                />
                            }
                        />
                    </Routes>
                </ThemeProvider>
            </IntlProvider>
        );
    }
    return <div></div>;
}

export default App;
